import { render, staticRenderFns } from "./WorkflowFormSubmissionFields.vue?vue&type=template&id=5a7dd3f6&scoped=true&"
import script from "./WorkflowFormSubmissionFields.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormSubmissionFields.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowFormSubmissionFields.vue?vue&type=style&index=0&id=5a7dd3f6&prod&lang=scss&"
import style1 from "./WorkflowFormSubmissionFields.vue?vue&type=style&index=1&id=5a7dd3f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7dd3f6",
  null
  
)

export default component.exports